module.exports = __webpack_public_path__ + "assets/img/m_bdt_img8.e7f2f18c.png";